module.exports = __webpack_public_path__ + "public/images/about-10.7f94be54fab8b1ed0a4c74a341d6e92e.png";